module.exports = __webpack_public_path__ + "static/rice-and-beans-4f2c93278cfeb023fb5e40d8799a4647.jpg";